import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Award: A funding agreement providing financial support for research, typically from a sponsor, that occurs over a period of time.',
    name: 'Awards',
    partialId: PartialId.Standard.create('awards'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
